import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { paginationPrefixCls } from "@/base/components/pagination/Pagination.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Pagination">> = ({
  colorActiveText,
  colorPrimary,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${paginationPrefixCls}`]: {
      display: "flex",
      alignItems: "center",

      [`.${paginationPrefixCls}-simple-pager`]: {
        lineHeight: "32px",
      },

      [`.${paginationPrefixCls}-item`]: {
        [`a`]: {
          transition: "none",
        },
        [`&.${paginationPrefixCls}-item-active a`]: {
          color: colorActiveText,
        },
      },
      [`.${paginationPrefixCls}-next, .${paginationPrefixCls}-prev`]: {
        [`.${ICON_PREFIX}`]: {
          fontSize: `16px`,
        },
        [`&:not(.${paginationPrefixCls}-disabled) .${ICON_PREFIX}`]: {
          color: colorPrimary,
        },
      },
    },
  },
});

export const usePaginationStyle = genComponentStyleHook(
  ["Pagination", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
